/* eslint-disable indent,import/prefer-default-export */
import fr from 'facet-rest';

// TODO: Option ordering
const hiddenFieldNames = [
];

export const HouseholdEscalationOverride = fr.metaOverride()
    .override({ readonly: true }, { hidden: true })
    .nameOverride(name => hiddenFieldNames.includes(name), { hidden: true })
    .nameOverride('escalationType', { ordinal: 0 })
    .nameOverride('escalationNote', {
        ordinal: 1,
        _customProps: {
          multiline: true,
        },
    })
    .nameOverride('saveAgent', { ordinal: 2 })
    .done();
